import { Quill } from '@/plugins/quilljs';

const Embed = Quill.import('blots/embed');

class AnchorBlot extends Embed {
  static create(value) {
    const node = super.create(value);
    node.innerHTML = 'bookmark';
    node.setAttribute('id', value);
    node.className = 'material-icons';
    return node;
  }

  static value(node) {
    return node.getAttribute('id');
  }
}

AnchorBlot.blotName = 'anchor-link';
AnchorBlot.tagName = 'i';

export default AnchorBlot;
